import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{attrs:{"id":"content"}},[_c(VContainer,{staticStyle:{"padding":"0px"}},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{attrs:{"cols":"12","md":"12"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.motpresident)}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }